module.exports = {"id":"177896","name":"Mario Vrančić","rating":"72","photo":"./data/images/photos/1/177896.png","club":{"name":"Norwich City","logo":"./data/images/clubs/NorwichCity.png"},"positions":["MC","MDC","MOC","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarioVrancic0.json
// module id = 2785
// module chunks = 0